/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicSitePropertyMedia = {
    url: string;
    kind?: PublicSitePropertyMedia.kind;
    title?: string;
    altText?: string;
};
export namespace PublicSitePropertyMedia {
    export enum kind {
        IMAGE = 'IMAGE',
        VIDEO = 'VIDEO',
        AUDIO = 'AUDIO',
        DOCUMENT = 'DOCUMENT',
    }
}

